import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

import Header from '../Header/container/Header'
import Footer from '../Footer/container/Footer'

import media from '../../../services/generateMediaQueries'
import ResponsiveAdsContainer from '../../ads/ResponsiveAdsContainer/ResponsiveAdsContainer'
import DesktopLeaderboard from '../../ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileLeaderboard from '../../ads/MobileLeaderboard/MobileLeaderboard'
// import HeaderPageLeaderboard from '../../ads/HeaderPageLeaderboard/HeaderPageLeaderboard'
// import HeaderPageMobileLead from '../../ads/HeaderPageMobileLead/HeaderPageMobileLead'
// import TASTagAds from '../../ads/TASTag/TASTag'
import TncModal from '../../../components/home/TncModal2/TncModal'
import PrivacyPolicyModal from '../../../components/home/PrivacyPolicyModal2/PrivacyPolicyModal'

import {
  getUserAgreementStatus,
  postUserAgreement,
} from '../../../services/api/requests/Dashboard'

const Layout = styled.div`
  min-height: 100vh;
  margin-top: -80px;
`

const ContentOverflowHelper = styled.div`
  position: relative;
`

const Content = styled.div`
  min-height: 100vh;
  overflow: hidden;
`

const BannerHelper = styled.div`
  position: relative;
  background: #000;
`

const Container = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  margin-top: -8.5rem;
  min-height: 100vh;

  ${media.lessThan('small')`
    margin-top: -6.5rem;
    ${props =>
      props.isEfoodChoices &&
      css`
        margin-top: 0;
      `}
    ${props =>
      props.isMallDirectory &&
      css`
        margin-top: -10.5rem;
      `}
  `}

  ${props =>
    props.isEConcierge &&
    css`
      margin-top: -13rem;
    `}
  ${props =>
    props.isEfoodChoices &&
    css`
      margin-top: 0;
    `}
`

const StyledFooter = styled(Footer)`
  margin-top: -6rem;
  padding-top: 6.5rem;

  ${props =>
    (props.isEConcierge || props.isEfoodChoices) &&
    css`
      padding-top: 12rem;
    `}
`
const TabOuterContainer = styled.div`
  width: 100%;
  height: 4rem;
  margin-top: -4rem;

  position: relative;
`
function CatalogLayout(props) {
  const {
    banner: Banner,
    children,
    match,
    isEConcierge,
    isEfoodChoices,
    isMallDirectory,
    selectedMall,
    accessToken,
    tabs,
  } = props

  const [tncAgreement, setTnC] = useState(true)
  const [privacyAgreement, setPrivacy] = useState(true)

  useEffect(() => {
    if (accessToken) {
      getTermsStatus()
    } else {
      setTnC(true)
      setPrivacy(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken])

  const getTermsStatus = async () => {
    try {
      const { data } = await getUserAgreementStatus(accessToken)
      const { tnc, privacy } = data || {}
      setTnC(tnc)
      setPrivacy(privacy)
    } catch {}
  }

  const toggleUserAgreementTnC = async () => {
    try {
      const agreementValue = {
        tnc: true,
      }
      const { data } = await postUserAgreement(accessToken, agreementValue)
      const { tnc } = data || {}
      setTnC(tnc)
    } catch {}
  }

  const toggleUserAgreementPrivacy = async () => {
    try {
      const agreementValue = {
        privacy: true,
      }
      const { data } = await postUserAgreement(accessToken, agreementValue)
      const { privacy } = data || {}
      setPrivacy(privacy)
    } catch {}
  }

  return (
    <>
      <div
        style={{
          backgroundColor: 'black',
        }}
      >
        <ResponsiveAdsContainer
          desktop={
            <>
              <DesktopLeaderboard id="div-ad-innity-91042/16" />
              {/* <HeaderPageLeaderboard id="div-totalmedia-16a" />
              <TASTagAds style={{ backgroundColor: 'black' }} /> */}
            </>
          }
          mobile={
            <>
              <MobileLeaderboard id="div-ad-innity-91045/16" />
              {/* <HeaderPageMobileLead id="div-totalmedia-16b" />
              <TASTagAds style={{ backgroundColor: 'black' }} /> */}
            </>
          }
        />
      </div>
      <Header match={match} initialMall={selectedMall} />
      <Layout>
        <ContentOverflowHelper>
          <Content>
            <BannerHelper>
              <Banner />
            </BannerHelper>
            {tabs && <TabOuterContainer>{tabs}</TabOuterContainer>}
            <Container
              isEConcierge={isEConcierge}
              isEfoodChoices={isEfoodChoices}
              isMallDirectory={isMallDirectory}
            >
              {children}
            </Container>
          </Content>
        </ContentOverflowHelper>
        <StyledFooter
          match={match}
          isEConcierge={isEConcierge}
          isEfoodChoices={isEfoodChoices}
        />
      </Layout>
      <PrivacyPolicyModal
        show={!privacyAgreement}
        onClose={() => setPrivacy(true)}
        onAgree={toggleUserAgreementPrivacy}
      />
      <TncModal
        show={!tncAgreement}
        onClose={() => setTnC(true)}
        onAgree={toggleUserAgreementTnC}
      />
    </>
  )
}

CatalogLayout.defaultProps = {
  // TODO: specify default props
}

CatalogLayout.propTypes = {
  // TODO: specify prop types
}

export default CatalogLayout
